export const en: Record<string, string> = {
  // ---------- Tabs ----------
  "tabs.dashboard": "Dashboard",
  "tabs.charts": "Charts",
  "tabs.records": "Records",
  "tabs.shifts": "Shifts",
  "tabs.people": "People",
  "tabs.settings": "Settings",
  "tabs.report": "Report",
  "tabs.emergency": "Emergency",
  "tabs.my_records": "My records",
  "tabs.turbines": "Turbines",
  "tabs.automatika": "Automation",

  // ---------- Автоматика (SCADA telemetry) ----------
  "auto.sub_overview": "Overview",
  "auto.sub_charts": "Charts",
  "auto.sub_anomalies": "Deviations",
  "auto.sub_data": "Data",
  "auto.all": "All",
  "auto.last_3d": "Last 3 days",
  "auto.last_1d": "Last day",
  "auto.data_range": "Data",
  "auto.timeframe": "Timeframe",
  "auto.tf_all": "All data",
  "auto.tf_7d": "Last 7 days",
  "auto.tf_3d": "Last 3 days",
  "auto.tf_1d": "Last 24 hours",
  "auto.tf_12h": "Last 12 hours",
  "auto.tf_6h": "Last 6 hours",
  "auto.tf_1h": "Last hour",
  "auto.tf_custom": "Custom range…",
  "auto.hide_zeros": "Hide zeros",
  "auto.truncated": "showing top 500",
  "auto.tap_for_details": "Tap for full snapshot",
  "auto.snapshot_title": "📸 State at this moment",
  "auto.resolution": "Resolution",
  "auto.res_auto": "Auto",
  "auto.res_raw": "Per-second",
  "auto.reset_zoom": "Reset zoom",
  "auto.deviations_n": "{n} flagged",
  "auto.drill_hint": "Tap any point to zoom in; or drag the bottom slider and tap “Zoom to selection”. Red points had a deviation in that interval.",
  "auto.zoom_to_sel": "Zoom to selection",
  "auto.back": "← Back",
  "auto.filter_metric": "Filter by metric",
  "auto.all_metrics": "All metrics",
  "auto.minutes": "min",
  "auto.min_short": "min",
  "auto.bucket": "bucket",
  "auto.kpi_running": "Running",
  "auto.kpi_peak_power": "Peak power",
  "auto.kpi_avg": "avg",
  "auto.kpi_span": "Period",
  "auto.kpi_energy": "Energy produced",
  "auto.kwh": "kWh",
  "auto.mwh": "MWh",
  "auto.col_metric": "Metric",
  "auto.no_anomalies": "No notable deviations in this period.",
  "auto.anomalies_hint": "{n} events (≥ {floor}% off normal, beyond ±2σ over running periods).",
  "auto.off_normal": "off normal",
  "auto.normal": "normal",
  "auto.when": "when",
  "auto.upload_title": "Upload a station CSV",
  "auto.upload_hint": "Space-separated SCADA export (.csv or .gz). Large files: upload .gz. Ingested in the background; data is separate from manual readings.",
  "auto.uploading": "Uploading…",
  "auto.upload_started": "Upload received — ingesting in the background…",
  "auto.upload_done": "Done — {rows} rows ingested.",
  "auto.upload_error": "Ingestion failed — check the file format.",
  "auto.export_xlsx": "📥 Download Excel (range)",
  "auto.export_hint": "Raw 1-sec rows for the selected period, original columns, one sheet per day.",
  "auto.imports_title": "Uploads",
  "auto.col_file": "File",
  "auto.col_status": "Status",
  "auto.col_rows": "Rows",
  "auto.col_period": "Period",

  // ---------- Turbines ----------
  "turbines.title": "🏭 Turbines",
  "turbines.empty_for_station": "Your station has no turbines yet. Ask an admin.",
  "turbines.none_for_station": "No turbines.",
  "turbines.active": "active",
  "turbines.inactive": "inactive",
  "turbines.status_running": "running",
  "turbines.status_stopped": "stopped",
  "turbines.status_off": "off",
  "turbines.activate": "Activate",
  "turbines.deactivate": "Deactivate",
  "turbines.state_running": "Running",
  "turbines.state_stopped": "Stopped",
  "turbines.state_off": "Out of service",
  "turbines.start_btn": "Start",
  "turbines.start_sub": "Record start with current KV",
  "turbines.start_title": "Start {name}",
  "turbines.confirm_start": "Start",
  "turbines.stop_btn": "Stop",
  "turbines.stop_sub": "Record stop with KW, time and reason",
  "turbines.stop_title": "Stop {name}",
  "turbines.confirm_stop": "Stop",
  "turbines.stop_time": "Time of stop",
  "turbines.stop_reason": "Reason",
  "turbines.stop_reason_placeholder": "Why was the turbine stopped?",
  "turbines.recent_events": "Event history",
  "turbines.evt_start": "Start",
  "turbines.evt_stop": "Stop",
  "turbines.tab_list": "Turbines",
  "turbines.tab_history": "History",
  "turbines.no_events": "No events yet.",
  "turbines.fill_btn": "Fill report",
  "turbines.fill_sub": "Log readings for this turbine",
  "turbines.fill_sub_offline": "Turbine stopped — entry will be orange",

  // ---------- Common ----------
  "common.loading": "Loading…",
  "common.cancel": "Cancel",
  "common.save": "Save",
  "common.delete": "Delete",
  "common.edit": "Edit",
  "common.create": "Create",
  "common.close": "Close",
  "common.retry": "Retry",
  "common.back": "Back",
  "common.add": "Add",
  "common.submit": "Submit",
  "common.no_changes": "No changes",
  "common.saved": "Saved",
  "common.copied": "Copied",
  "common.copy_link": "📋 Copy link",
  "common.no_data": "No data for the selected period.",
  "common.empty": "Nothing here yet.",
  "common.error_generic": "Something went wrong. Try again.",
  "common.no_connection": "No connection to the server",
  "common.timeout": "Server not responding — try again",

  // ---------- Access / desktop hint ----------
  "access.locked_title": "Access denied",
  "access.locked_hint": "Only registered users can open this app. Ask an administrator for an invite link.",
  "desktop_hint.title": "Open in Telegram",
  "desktop_hint.body": "This is a Telegram Mini App. Open the bot in your phone or desktop Telegram and tap 📱 next to the input.",

  // ---------- Periods ----------
  "period.today": "Today",
  "period.yest": "Yesterday",
  "period.7d": "7 days",
  "period.30d": "30 days",
  "period.all": "All",

  // ---------- Status / types ----------
  "status.completed": "✅",
  "status.miss_short": "miss",
  "type.plan": "Plan",
  "type.emergency": "🚨 Emergency",
  "type.missed": "🚫 Missed",
  "type.late": "🟨 Late",
  "type.offline": "🟠 Offline",
  "filter.all": "All",

  // ---------- Charts ----------
  "charts.title": "📈 Charts",
  "charts.select_chart": "Select a chart",
  "charts.turbine": "Turbine",
  "charts.period": "Period",
  "charts.kw_kv_label": "KW & KV fluctuations",
  "charts.kw_kv_title": "KW & KV over time",
  "charts.kw_kv_hint": "Two lines: KW (left axis) and KV (right axis). Voltage spikes are easy to spot.",
  "charts.kw_kv_offline_title": "KW & KV trend (turbine stopped)",
  "charts.kw_kv_offline_hint": "Only records taken while the turbine was stopped. KW (orange, left axis) and KV (purple, right axis).",

  "charts.compare_label": "Compare turbines (KW)",
  "charts.compare_hint": "Power curves of all turbines on one chart. Useful for spotting uneven load distribution and idle turbines.",

  "charts.timeline_label": "Run / downtime timeline",
  "charts.timeline_hint": "Horizontal bars per turbine: green segments = running, red = stopped. The whole downtime for the period fits on one screen.",
  "charts.timeline_running": "Running",
  "charts.timeline_stopped": "Stopped",

  "charts.temperatures_label": "BT temperatures",
  "charts.temperatures_hint": "Temperature sensors BT 371, BT 372, BT 331, BT 332 on a single chart. A sharp spike means overheating risk.",

  "charts.frequency_label": "Frequency (Hz)",
  "charts.frequency_hint": "Generation frequency in Hz with reference lines at 49.5 and 50.5. Any deviation over 0.5 Hz means a grid problem.",
  "charts.freq_low": "49.5 Hz (low)",
  "charts.freq_high": "50.5 Hz (high)",

  "charts.stop_reasons_label": "Stop reasons",
  "charts.stop_reasons_hint": "Distribution of reason fields from turbine Stop events. Shows which problems happen most often and where to focus.",
  "charts.stop_reasons_empty": "No turbine stops in this period.",
  "charts.reason_unknown": "Unspecified",

  "charts.kw_histogram_label": "KW distribution (histogram)",
  "charts.kw_histogram_hint": "How many readings fell into each 200-KW bucket. Reveals the operating mode the turbine spends most of its time in.",

  "charts.cos_kvar_label": "cos φ and Kvar",
  "charts.cos_kvar_hint": "Power factor cos φ (left axis, 0..1) and reactive power Kvar (right axis). Dropping cos φ = generation quality issues.",

  "charts.pressure_label": "Pressures (BP 371, Bar, Pipe pressure)",
  "charts.pressure_hint": "All pressures on one chart. Sharp swings indicate emergency conditions in the hydraulic or steam loop.",

  "charts.scatter_label": "KW vs KV (scatter)",
  "charts.scatter_hint": "Scatter plot, each dot = one reading. Shows correlation between power and voltage; outliers stand out.",

  "analysis.title": "Analysis",
  "analysis.no_data": "Not enough data in this period to analyse.",
  "analysis.records": "Records considered: {n}.",

  "analysis.kv_ok": "Voltage within normal range (KV {min}–{max}, target 17–22).",
  "analysis.kv_out": "Voltage outside normal range (KV {min}–{max}, expected 17–22). Check grid status.",
  "analysis.kw_stable": "Power output is stable, average {avg} KW.",
  "analysis.kw_unstable": "Power output unstable: spread is {cv}% of the {avg} KW average. Inspect the load.",

  "analysis.turbine_idle": "{name}: no data in this period — turbine was idle.",
  "analysis.turbine_avg": "{name}: average power {avg} KW.",
  "analysis.compare_balanced": "Load is evenly distributed across turbines.",
  "analysis.compare_imbalance": "Load imbalance: {hi} ({hiAvg} KW) significantly higher than {lo} ({loAvg} KW).",

  "analysis.timeline_overall": "Combined uptime across all turbines: {uptime}%. Total stops: {stops}.",
  "analysis.timeline_turbine": "{name}: running {uptime}% of the time, downtime {downtime}.",

  "analysis.temp_ok": "Temperatures normal, max {max}°C (threshold 70°C).",
  "analysis.temp_warn": "Elevated temperature, max {max}°C. Normal up to 70°C, critical above 85°C — watch the sensors.",
  "analysis.temp_critical": "Overheating! Max {max}°C on sensors: {sensors}. Attention required.",
  "analysis.temp_avg": "Average temperature: {avg}°C.",

  "analysis.freq_ok": "Frequency stable: {min}–{max} Hz, within the 49.5–50.5 normal band.",
  "analysis.freq_bad": "Frequency went out of range: below 49.5 — {low} points, above 50.5 — {high} (of {total}).",
  "analysis.freq_avg": "Average frequency: {avg} Hz.",

  "analysis.stop_none": "No turbine stops in this period — excellent.",
  "analysis.stop_total": "Total stops: {n}.",
  "analysis.stop_top": "Most common reason: «{name}» ({pct}%).",
  "analysis.stop_dominant": "One reason dominates: «{name}» ({pct}% of all stops). Worth investigating the source.",
  "analysis.stop_variety": "Variety of reasons: {n} distinct categories.",

  "analysis.hist_top": "Most often power is in the {range} KW band ({pct}%).",
  "analysis.hist_low": "{pct}% of records at low power — frequent under-loading.",
  "analysis.hist_normal": "{pct}% of time running at normal load.",
  "analysis.hist_avg": "Average power: {avg} KW.",

  "analysis.cos_ok": "cos φ normal (avg {avg}). High generation quality.",
  "analysis.cos_warn": "cos φ reduced (avg {avg}). Normal ≥0.95, reactive-power compensation recommended.",
  "analysis.cos_bad": "cos φ low (avg {avg}). Significant losses — under-loading or large reactive load.",
  "analysis.kvar_avg": "Kvar: avg {avg}, range {min}–{max}.",

  "analysis.pressure_field": "{name}: avg {avg}, range {min}–{max}.",

  "analysis.scatter_few": "Too few points to analyse correlation.",
  "analysis.scatter_points": "{n} points on the chart.",
  "analysis.scatter_corr_pos": "Strong positive correlation between KW and KV (r={r}). Voltage rises with power.",
  "analysis.scatter_corr_neg": "Strong negative correlation between KW and KV (r={r}). Voltage drops as power rises.",
  "analysis.scatter_corr_none": "No clear correlation between KW and KV (r={r}).",

  // ---------- Dashboard ----------
  "dashboard.title": "📊 Dashboard",
  "dashboard.kpi.completed": "Completed",
  "dashboard.kpi.completed_sub": "{pct}% of plan",
  "dashboard.kpi.total": "Total slots",
  "dashboard.kpi.missed": "🚫 Missed",
  "dashboard.kpi.late": "🟨 Late",
  "dashboard.kpi.emergency": "🚨 Emergency",
  "dashboard.kpi.avg_response": "Avg response",
  "dashboard.kpi.avg_response_sub": "From notification to start",
  "dashboard.kpi.avg_kw": "Average KW",
  "dashboard.kpi.avg_kv": "Average KV",
  "dashboard.kpi.min_max_sub": "min / max for the period",
  "dashboard.kpi.min": "min",
  "dashboard.kpi.max": "max",
  "dashboard.turbines.downtime": "Downtime",
  "dashboard.turbines.last_reading": "Last reading",
  "dashboard.turbines.no_downtime": "No downtime",
  "dashboard.turbines.no_data": "no data",
  "dashboard.turbines.just_now": "just now",
  "dashboard.turbines.ago": "ago",
  "dashboard.turbines.unit_d": "d",
  "dashboard.turbines.unit_h": "h",
  "dashboard.turbines.unit_min": "min",
  "dashboard.sparkline.title": "KW trend, last 24 h",
  "dashboard.sparkline.hint": "All online power readings across both turbines",
  "dashboard.distribution.title": "Slot distribution",
  "dashboard.distribution.on_time": "✅ On time",
  "dashboard.distribution.late": "🟨 Late",
  "dashboard.distribution.missed": "🚫 Missed",
  "dashboard.distribution.pending": "⏳ In progress",
  "dashboard.distribution.emergency": "🚨 Emergency",
  "dashboard.by_day.title": "Completion by day, %",
  "dashboard.by_day.tooltip": "{pct}% ({completed}/{total})",
  "dashboard.by_day.tooltip_label": "Completion",
  "dashboard.by_hour.title": "Completion by hour of day",
  "dashboard.by_hour.legend": "🟢 high · 🟡 mid · 🔴 low",
  "dashboard.by_hour.legend_count": "Number of reports submitted in each hour of the day (across the period).",
  "dashboard.by_hour.no_data": "no data",
  "dashboard.users.title": "Operator ranking",
  "dashboard.users.col_name": "Name",
  "dashboard.users.col_avg": "Avg response",
  "dashboard.users.bar_title": "Average response time, sec",
  "dashboard.empty": "No data for the selected period. Try another period or wait for the next hourly tick.",

  // ---------- Records (admin) ----------
  "records.title": "📋 Records",
  "records.from": "From",
  "records.to": "To",
  "records.download_xlsx": "📥 Download Excel",
  "records.xlsx_per_day": "Each day in the range becomes its own sheet (per the readings ledger).",
  "records.custom_preview": "🛠 Custom preview",
  "records.col_date": "Date",
  "records.col_turbine": "Turbine",

  "custom_preview.title": "🛠 Custom preview",
  "custom_preview.period": "Period",
  "custom_preview.turbine": "Turbine",
  "custom_preview.type": "Record type",
  "custom_preview.fields": "Selected: {n} of {total}",
  "custom_preview.select_all": "Select all",
  "custom_preview.clear": "Clear",
  "custom_preview.build_btn": "Build table",
  "custom_preview.building": "Building…",
  "custom_preview.rows_count": "Total rows: {n}",
  "custom_preview.sort_hint": "Click to sort",
  "records.col_slot": "Slot",
  "records.col_who": "Who",
  "records.col_type": "Type",
  "records.col_status": "Status",
  "records.detail.title": "Record #{id}",
  "records.detail.slot": "Slot",
  "records.detail.responsible": "Responsible",
  "records.detail.started": "Started",
  "records.detail.completed": "Completed",
  "records.detail.response": "Response",
  "records.detail.fill": "Fill time",
  "records.detail.reason": "Reason",
  "records.detail.seconds": "s",

  // ---------- My records (responsible) ----------
  "my_records.title": "📋 My records",
  "my_records.download_xlsx": "📥 Download Excel",

  // ---------- Shifts (admin) ----------
  "shifts.title": "📅 Shifts",
  "shifts.choose_user": "Choose a responsible",
  "shifts.fill_range": "📐 Fill range",
  "shifts.active_count": "Active shifts ({n})",
  "shifts.empty": "No shifts yet. Tap a day in the calendar.",
  "shifts.range.title": "📐 Fill range",
  "shifts.range.from": "Start",
  "shifts.range.to": "End",
  "shifts.range.invalid": "End date is before start date",
  "shifts.range.added": "Added: {added}, skipped: {skipped}",
  "shifts.deactivated": "deactivated",
  "shifts.more_hidden": "…and {n} more (hidden)",

  // ---------- People & stations ----------
  "people.title": "👥 People and stations",
  "people.stations": "🏭 Stations ({n})",
  "people.add_station": "➕ Add station",
  "people.station.name": "Name",
  "people.station.city": "City",
  "people.station.tz": "Timezone (Europe/Kyiv)",
  "people.station.new_title": "New station",
  "people.station.name_placeholder": "Name (e.g. Energo-2)",
  "people.station.confirm_delete": "Delete station «{name}»?",
  "people.station.fill_required": "Fill name and city",
  "people.invite.title": "New invite",
  "people.invite.placeholder": "Operator's full name",
  "people.invite.create": "➕ Create invite",
  "people.invite.created_for": "✅ Invite for «{name}»",
  "people.invite.copy_failed": "Couldn't copy. Select the link manually.",
  "people.list_title": "Responsibles ({n})",
  "people.list_empty": "No one yet. Create an invite.",
  "people.deactivate": "Deactivate",
  "people.activate": "Activate",
  "people.station_label": "Station:",
  "people.station_none": "— no station —",

  // ---------- Settings ----------
  "settings.title": "⚙ Settings",
  "settings.notification_interval": "Notification interval, min ({min}–{max})",
  "settings.notification_hint": "Every {n} minutes operators get a Telegram ping. Applies from the next tick.",
  "settings.range_error": "Allowed range: {min}–{max}",
  "settings.language": "Language",
  "settings.trigger_running": "Running…",
  "settings.trigger_label": "⚡ Trigger: fire hourly tick",
  "settings.trigger_success": "✅ Tick fired. Operators on shift will receive notifications.",
  "settings.trigger_failed": "⚠ {error}",

  // ---------- Report (responsible landing) ----------
  "report.title": "📝 Report",
  "report.ready_to_fill": "Ready to submit. Tap the button below.",
  "report.no_slot": "⏳ Submission unavailable",
  "report.no_slot_hint": "Turbine is stopped or you are on a day off.",
  "report.day_off": "🌴 You are on a day off today",
  "report.day_off_hint": "Notifications are paused until the end of the shift.",
  "report.fill_btn": "Fill report",
  "report.fill_btn_offline": "Fill (turbine stopped)",
  "report.fill_sub_active": "Plan readings for the current hour",
  "report.fill_sub_disabled": "Not available right now",
  "report.fill_sub_day_off": "Unavailable — day off",
  "report.fill_sub_offline": "Entry will be flagged orange",
  "report.emergency_btn": "Emergency",
  "report.emergency_sub": "Unplanned entry: KW + KV",
  "report.day_off_btn_off": "Day off",
  "report.day_off_btn_on": "Cancel day off",
  "report.day_off_sub_off": "Mark today as a non-working day",
  "report.day_off_sub_on": "Resume shift notifications",
  "report.day_off_confirm_on": "Mark today as a day off? You will stop receiving notifications for this shift.",
  "report.day_off_confirm_off": "Cancel day off — notifications will resume?",

  // ---------- Report form ----------
  "report_form.title": "📋 Plan report",
  "report_form.slot_label": "Slot",
  "report_form.placeholder_pair": "X or X/Y",
  "report_form.placeholder_single": "—",
  "report_form.filled_count": "Filled {n} of {total}. Partial submit is allowed.",
  "report_form.expand_all": "Expand all",
  "report_form.collapse_all": "Collapse all",
  "bool.on": "On",
  "bool.off": "Off",
  "report_form.submit": "Submit",
  "report_form.submit_sub": "Save the entered values",
  "report_form.submitting": "Submitting…",
  "report_form.cancel": "Cancel",
  "report_form.cancel_sub": "Values will not be saved",
  "report_form.already_completed": "This slot is already completed.",
  "report_form.no_slot": "No open slot.",
  "report_form.offline_title": "Turbine is stopped",
  "report_form.offline_hint": "The entry will still be saved, but flagged in orange so reviewers see it was logged while the turbine was idle.",

  // ---------- Emergency form ----------
  "emergency.title": "🚨 Emergency",
  "emergency.intro": "Unplanned entry. KW and a reason are required; other indicators are optional. Admins will be notified after submit.",
  "emergency.reason_label": "Reason",
  "emergency.reason_placeholder": "Describe what happened",
  "emergency.reason_required": "Required field",
  "emergency.submit_sub_ok": "Save and notify administrators",
  "emergency.submit_sub_disabled": "Provide a reason first",
  "emergency.show_extras": "Fill remaining fields (optional)",
  "emergency.hide_extras": "Hide remaining fields",
  "emergency.landing_what": "What is «Emergency»?",
  "emergency.landing_when": "Use this ONLY for real abnormal events — failure, surge, leak, etc.",
  "emergency.landing_warn": "If you just want to log routine readings — close this tab and use «📝 Report».",
  "emergency.landing_btn": "Create emergency entry",
};
